import Vue from "vue";
import teamService from "@/services/team";
import TeamStatus from "@/components/teams/TeamStatus";

function defaultState() {
  return {
    team: null,
    isEdit: false,
    isOwnerMode: false
  };
}

const state = defaultState();

const getters = {
  mainInfo({ team }) {
    if (!team) return null;
    const { city_id } = team;
    return { city_id };
  },
  isApproved({ team }) {
    return team && team.status === TeamStatus.Approved;
  },
  isDisabled(state) {
    return !state.isOwnerMode;
  }
};

const mutations = {
  clear(state) {
    Object.assign(state, defaultState());
  },
  setTeam(state, team) {
    state.team = team;
  },
  startEdit(state) {
    state.isEdit = true;
  },
  setOwnerMode(state) {
    state.isOwnerMode = true;
  },
  endEdit(state, teamInfo) {
    state.isEdit = false;
    if (teamInfo) {
      for (let key in teamInfo) {
        Vue.set(state.team, key, teamInfo[key]);
      }
    }
  },
  addMember(state, member) {
    state.team.roster.push(member);
  },
  updateMember(state, member) {
    const index = state.team.roster.findIndex(item => item.id === member.id);
    if (~index) Vue.set(state.team.roster, index, member);
  }
};

const actions = {
  async fetchTeam({ commit }) {
    const { data, success } = await teamService.getOwnTeam();
    if (success) {
      commit("setTeam", data);
      commit("setOwnerMode");
    }
    return { success };
  },

  async saveChanges({ commit }, teamInfo) {
    const { data, success, message } = await teamService.updateTeam(teamInfo);
    if (success) {
      commit("endEdit", data);
    }
    return { success, message };
  },

  async addMember({ dispatch }, member) {
    const { data, success, message } = await teamService.addMember(member);
    if (success) {
      dispatch("fetchTeam");
    }
    return { success, data, message };
  },

  async updateMember({ dispatch }, member) {
    const { data, success, message } = await teamService.updateMember(member);
    if (success) {
      dispatch("fetchTeam");
    }
    return { success, data, message };
  }
};

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state
};
